import React from 'react';
import { useFormMethods } from '../../../../../helpers/formManager';
import { fieldPathBuilders } from '../../../shared/configs/acceptanceForm';
import { createDefaultNumber } from '../../../services/desk';
import { actionCreators, sliceKeys } from '../../../model';
import RemoveFieldset from '../../../controllers/RemoveFieldset';
import DuplicateFieldset from '../../../controllers/DuplicateFieldset';
import { useDeskIsImmutable } from '../hooks/isImmutableFns';
import styles from './index.module.scss';

const { byIndex: createDeskFieldsetName, name: createDeskName } =
  fieldPathBuilders.desk;

const { activeDeskIndexChanged } = actionCreators[sliceKeys.desks];

const Actions = ({ index }) => {
  const { getValues, reset } = useFormMethods();

  const createConfirmData = () => {
    const desk = getValues(createDeskName(index));

    const name = desk?.label || createDefaultNumber(index);
    const title = name ? `Удалить стол «${name}»?` : 'Удалить стол?';

    const onAfterRemove = () => {
      reset(getValues());
    };

    return { index, title, onAfterRemove };
  };

  const immutable = useDeskIsImmutable(index);

  return (
    <>
      {!immutable && (
        <RemoveFieldset
          createConfirmData={createConfirmData}
          action={activeDeskIndexChanged}
        />
      )}
      <DuplicateFieldset
        fieldsetName={createDeskFieldsetName(index)}
        action={activeDeskIndexChanged}
        className={styles.duplicateFieldset}
      />
    </>
  );
};

export default Actions;
